import request from '../request'
import { Pass_Knowledge_Url } from '../../conf'
import { TagModel } from '../../model/tag.model'
import {
    KnowledgeModel,
    KnowledgeAnswerModel,
} from '../../model/knowledge.model'

interface ErrorModel {
    error_code: number
    error_name: string
    detail: string
}
export interface PaginationModel {
    page: number
    page_size: number
}
interface MutationResponseModel {
    successfully: boolean
    data: boolean
    error: ErrorModel
}

interface QueryContentModel {
    keywords: string
    querytype: 'all'
}
interface GetKnowledgeListRequest {
    appHash: string
    pagination: PaginationModel
    status?: number
    tagId: number | string
    sortKey?: string
    answerNum?: number
    queryContent?: QueryContentModel
}
interface GetKnowledgeListResponse {
    data: {
        getKnowledgeList: {
            count: number
            rows: KnowledgeModel[]
        }
    }
}
export const getKnowledgeList = async (
    data: GetKnowledgeListRequest
): Promise<GetKnowledgeListResponse> => {
    const query = `
        query GetKnowledgeList($appHash: String!, $pagination: Pagination!, $status: Int!, $tagId: Int!, $sortKey: String!, $answerNum: Int,$queryContent: KnowledgeQueryInput!) {
            getKnowledgeList(app_hash: $appHash, page: $pagination, status: $status, tag_id: $tagId, sort_key: $sortKey,  answer_num: $answerNum, query_content: $queryContent) {
                count
                rows {
                    k_id
                    k_title
                    k_answer
                    q_count
                    status
                    KAnswers {
                        k_id
                        ka_id
                        k_answer
                    }
                    KQuestions {
                        k_id
                        kq_id
                        k_question
                    }
                }
            }
        }
    `

    const variables: GetKnowledgeListRequest = {
        status: -1,
        answerNum: -2,
        sortKey: 'db_update_time-desc',
        queryContent: {
            keywords: '',
            querytype: 'all',
        },
        ...data,
    }
    const operationName = 'GetKnowledgeList'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

interface GetKnowledgeTagListRequest {
    tagParent: number
    appHash: string
}
interface GetKnowledgeTagListResponse {
    data: {
        getTagList: TagModel[]
    }
}
export const getKnowledgeTagList = async (
    data: GetKnowledgeTagListRequest
): Promise<GetKnowledgeTagListResponse> => {
    const query = `
        query getKTagList($tagParent: Int!, $appHash: String!) {
            getTagList(tag_parent: $tagParent, app_hash: $appHash) {
                ktag_id
                ktag_name
                parent_ktag_id
                has_children
                count
                __typename
            }
      }      
    `
    const operationName = 'getKTagList'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables: data,
        operationName,
    })
}

// 相似问添加数据类型
export interface QAddModel {
    k_id?: number
    k_question: string
}
export interface KnowledgeUpdateModel {
    k_id?: number
    k_title: string
    q_count?: number
    respond_all?: number
    status?: number
}
export interface KnowledgeAnswerAddModel {
    k_answer: string
    k_id?: number
}
export interface KnowledgeTagAddModel {
    k_id: number
    ktag_id: number
}
export interface UpdateKnowledgeRequest {
    appHash: string
    kId?: number
    qAdd?: QAddModel[]
    tagAdd?: KnowledgeTagAddModel[]
    qUp?: any[]
    qDel?: any[]
    kUp?: KnowledgeUpdateModel
    aAdd?: KnowledgeAnswerAddModel[]
    aDel?: number[]
    aUp?: KnowledgeAnswerModel[]
    rqId?: number
    KnowledgeEntityList?: any
    sentenceList?: any[]
}
export interface UpdateKnowledgeResponse {
    data: {
        updateKnowledge: MutationResponseModel
    }
}
export const updateKnowledge = (
    data: UpdateKnowledgeRequest
): Promise<UpdateKnowledgeResponse> => {
    const query = `
        mutation updateKnowledge($appHash: String!, $kId: Int!, $qAdd: [KnowledgeQuestionInput], $qUp: [KnowledgeQuestionInput], $qDel: [Int], $kUp: KnowledgeInput, $aAdd: [KnowledgeAnswerInput], $aDel: [Int], $aUp: [KnowledgeAnswerInput], $KnowledgeEntityList: [IKeepEntity], $sentenceList: [SentenceInput]) {
            updateKnowledge(app_hash: $appHash, k_id: $kId, q_add: $qAdd, q_up: $qUp, q_del: $qDel, k_up: $kUp, a_add: $aAdd, a_del: $aDel, a_up: $aUp, KnowledgeEntityList: $KnowledgeEntityList, sentenceList: $sentenceList) {
                data
                error {
                    error_code
                    error_name
                    detail
                    __typename
                }
                __typename
            }
        }
    `
    const variables: UpdateKnowledgeRequest = {
        qAdd: [],
        qDel: [],
        qUp: [],
        aAdd: [],
        aDel: [],
        aUp: [],
        rqId: 0,
        // KnowledgeEntityList: null,
        sentenceList: [],
        ...data,
    }
    const operationName = 'updateKnowledge'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

export interface AddKnowledgeRequest extends UpdateKnowledgeRequest {
    kUp: KnowledgeUpdateModel
    KnowledgeEntityList?: any[]
}

export interface AddKnowledgeResponse {
    data: {
        addKnowledge: MutationResponseModel
    }
}
export const addKnowledge = async (
    data: AddKnowledgeRequest
): Promise<AddKnowledgeResponse> => {
    const query = `
        mutation addKnowledge($appHash: String!, $qAdd: [KnowledgeQuestionInput], $kUp: KnowledgeInput, $aAdd: [KnowledgeAnswerInput],$tagAdd: [KnowledgeTagMappingInput], $rqId: Int, $KnowledgeEntityList: [IKeepEntity]) {
            addKnowledge(app_hash: $appHash, q_add: $qAdd, a_add: $aAdd, tag_add: $tagAdd, k_up: $kUp, rq_id: $rqId, KnowledgeEntityList: $KnowledgeEntityList) {
            data
            error {
                error_code
                error_name
                detail
                __typename
            }
            __typename
            }
        }
    `
    const variables: UpdateKnowledgeRequest = {
        qAdd: [],
        qDel: [],
        qUp: [],
        aAdd: [],
        aDel: [],
        aUp: [],
        rqId: 0,
        ...data,
    }
    const operationName = 'addKnowledge'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

interface DeleteKnowledgeRequest {
    kId: number
    appHash: string
}
interface DeleteKnowledgeResponse {
    data: {
        deleteKnowledge: MutationResponseModel
    }
}
export const deleteKnowledge = async (
    data: DeleteKnowledgeRequest
): Promise<DeleteKnowledgeResponse> => {
    const query = `
        mutation delKnowledge($kId: Int!, $appHash: String!) {
            deleteKnowledge(k_id: $kId, app_hash: $appHash) {
            successfully
            error {
                error_code
                error_name
                detail
                __typename
            }
            __typename
            }
        }
    `
    const variables = data
    const operationName = 'delKnowledge'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}
interface ListIdentityQuestionsRequest {
    appHash: string
    pagination: PaginationModel
}
export interface QuestionTopNItem {
    recId: number
    recItemId: number
    knowledgeInfo: {
        title: string
        question: string
        answer: string
    }
}
export interface IdentityQuestionItem {
    questionId: number
    userQuestion: string
    topNList: QuestionTopNItem[]
}
interface ListIdentityQuestionsResponse {
    data: {
        listIdentityQuestions: {
            count: number
            rows: IdentityQuestionItem[]
        }
    }
}
export const listIdentityQuestions = async (
    data: ListIdentityQuestionsRequest
): Promise<ListIdentityQuestionsResponse> => {
    const query = `
        query listIdentityQuestions($appHash: String!, $order: [String], $dateRange: [Int], $scoreRange: [Float], $pagination: Pagination) {
            listIdentityQuestions(appHash: $appHash, order: $order, dateRange: $dateRange, scoreRange: $scoreRange, pagination: $pagination) {
            count
            rows {
                questionId
                userQuestion
                topNList {
                recId
                recItemId
                itemType
                recScore
                knowledgeInfo {
                    title
                    question
                    answer
                    __typename
                }
                taskInfo {
                    title
                    triggerQuestion
                    slotList
                    __typename
                }
                __typename
                }
                __typename
            }
            __typename
            }
        }
    `
    const variables = {
        dateRange: null,
        order: ['db_insert_time', 'desc'],
        scoreRange: null,
        ...data,
    }
    const operationName = 'listIdentityQuestions'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

export interface SearchedKnowledgeModel {
    k_id: number
    k_title: string
    k_question?: string
    k_answer?: string
    k_answer_type?: string
}
interface GetKnowledgesByTitleRequest {
    appHash: string
    title: string
}

interface GetKnowledgesByTitleResponse {
    data: {
        getKnowledgeByTitle: SearchedKnowledgeModel[]
    }
}
export const getKnowledgesByTitle = async (
    data: GetKnowledgesByTitleRequest
): Promise<GetKnowledgesByTitleResponse> => {
    const query = `
        query getKnowledgeByTitle($title: String!, $appHash: String!) {
            getKnowledgeByTitle(title: $title, app_hash: $appHash) {
            k_id
            k_title
            k_question
            k_answer
            k_answer_type
            __typename
            }
        }
    `
    const variables = data
    const operationName = 'getKnowledgeByTitle'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}
interface MergeIdentityQuestionToKnowledgeRequest {
    kId: number
    questionList: string[]
    appHash: string
    iqIdList: number[]
}
interface MergeIdentityQuestionToKnowledgeResponse {
    data: {
        mergeIdentityQuestionToKnowledge: {
            successfully: boolean
            error: ErrorModel
        }
    }
}
export const mergeIdentityQuestionToKnowledge = async (
    data: MergeIdentityQuestionToKnowledgeRequest
): Promise<MergeIdentityQuestionToKnowledgeResponse> => {
    const query = `
        mutation mergeIdentityQuestionToKnowledge($kId: Int!, $questionList: [String!], $appHash: String!, $iqIdList: [Int]!) {
            mergeIdentityQuestionToKnowledge(kId: $kId, questionList: $questionList, appHash: $appHash, iqIdList: $iqIdList) {
            successfully
            error {
                error_code
                error_name
                detail
                __typename
            }
            __typename
            }
        }
    `
    const variables = data
    const operationName = 'mergeIdentityQuestionToKnowledge'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

interface DeleteIdentityQuestionRequest {
    appHash: string
    questionIdList: number[]
}
interface DeleteIdentityQuestionResponse {
    data: {
        deleteIdentityQuestion: {
            successfully: boolean
            error: ErrorModel
        }
    }
}
export const deleteIdentityQuestion = async (
    data: DeleteIdentityQuestionRequest
): Promise<DeleteIdentityQuestionResponse> => {
    const query = `
        mutation deleteIdentityQuestion($appHash: String!, $questionIdList: [Int]!) {
            deleteIdentityQuestion(appHash: $appHash, questionIdList: $questionIdList) {
            successfully
            error {
                error_code
                error_name
                detail
                __typename
            }
            __typename
            }
        }
    `
    const variables = data
    const operationName = 'deleteIdentityQuestion'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

interface GetKnowledgeDetailRequest {
    kId: number
    appHash: string
}
interface GetKnowledgeDetailResponse {
    data: {
        getKnowledge: KnowledgeModel
    }
}
export const getKnowledgeDetail = async (
    data: GetKnowledgeDetailRequest
): Promise<GetKnowledgeDetailResponse> => {
    const query = `
        query getKnowledge($appHash: String!, $kId: Int!) {
            getKnowledge(app_hash: $appHash, k_id: $kId) {
            k_id
            k_title
            k_used_times
            status
            q_count
            db_insert_time
            db_update_time
            respond_all
            action
            is_label
            KQuestions {
                kq_id
                k_question
                __typename
            }
            KTagMappings {
                id
                k_id
                ktag_id
                KTag {
                ktag_id
                ktag_name
                parent_ktag_id
                path
                __typename
                }
                __typename
            }
            KAnswers {
                ka_id
                k_id
                k_answer
                k_answer_type
                score
                is_disable
                src_id
                top_reply
                __typename
            }
            __typename
            }
        }
    `
    const variables = data
    const operationName = 'getKnowledge'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

interface UpdateIdentityQuestionRequest {
    identityQuestionId: number
    appHash: string
    content: string
}

interface UpdateIdentityQuestionResponse {
    data: {
        updateIdentityQuestion: MutationResponseModel
    }
}
export const updateIdentityQuestion = async (
    data: UpdateIdentityQuestionRequest
): Promise<UpdateIdentityQuestionResponse> => {
    const query = `
        mutation updateIdentityQuestion($identityQuestionId: Int!, $appHash: String!, $content: String!) {
            updateIdentityQuestion(identityQuestionId: $identityQuestionId, appHash: $appHash, content: $content) {
            successfully
            error {
                error_code
                error_name
                detail
                __typename
            }
            __typename
            }
        }
    `
    const variables = data
    const operationName = 'updateIdentityQuestion'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}
// 更新默认回复
interface UpdateReplyConfigParams {
    appHash: string
    replyList: GeneralReply[]
}
interface GeneralReply {
    answer: string
    answer_type: number
    answer_id: number
}
interface UpdateReplyConfigParamsResponse {
    data: {
        updateReplyConfig: MutationResponseModel
    }
}
export const updateReplyConfig = async (
    params: UpdateReplyConfigParams
): Promise<UpdateReplyConfigParamsResponse> => {
    const query = `mutation updateReplyConfig($appHash: String!, $config: updateReplyConfigParams!) {
        updateReplyConfig(app_hash: $appHash, config: $config) {
          successfully
          error {
            ...ErrorFragment
            __typename
          }
          __typename
        }
      }
      
      fragment ErrorFragment on Error {
        error_code
        error_name
        detail
        __typename
      }`
    const variables = {
        appHash: params.appHash,
        config: {
            bot: {
                general_reply_list: params.replyList,
            },
        },
    }
    const operationName = 'updateReplyConfig'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

interface GetReplyConfigResponse {
    data: {
        replyConfig: {
            rows: [
                {
                    bot: {
                        general_reply_list: GeneralReply[]
                    }
                }
            ]
            successfully: boolean
        }
    }
}
// 获取默认回复
export const getReplyConfig = async (
    appHash: string
): Promise<GetReplyConfigResponse> => {
    const query = `query replyConfig($appHash: String!) {
        replyConfig(app_hash: $appHash) {
          successfully
          count
          rows {
            bot {

              general_reply_list {
                answer_id
                answer_type
                answer
                __typename
              }
            }
            __typename
          }
          error {
            ...ErrorFragment
            __typename
          }
          __typename
        }
      }
      
      fragment ErrorFragment on Error {
        error_code
        error_name
        detail
        __typename
      }`
    const variables = {
        appHash: appHash,
    }
    const operationName = 'replyConfig'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

export const uploadFile = async (file: File) => {
    const url = '/wulai/store/callback/upload'
    const formData = new FormData()
    formData.append('file', file)
    return request.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}

/**
 * 获取知识点七日收到的消息数量 + 召回率
 */
interface KnowledgeQAHistory {
    data: {
        getQABotHistory: {
            receiveMessageNumber: number
            recallNumber: number
            recallRate: number
            date: number
            __typename: string
        }[]
    }
}

export const getKnowledgeQAHistory = ({
    startDate,
    endDate,
    appHash,
}: {
    startDate: string
    endDate: string
    appHash: string
}): Promise<KnowledgeQAHistory> => {
    const query = `query qABotHistory($startDate: Int!, $endDate: Int!, $appHash: String!) {
    getQABotHistory(start_date: $startDate, end_date: $endDate, app_hash: $appHash) {
      receiveMessageNumber
      recallNumber
      recallRate
      date
      __typename
    }
  }`

    return request.post(Pass_Knowledge_Url, {
        query,
        variables: {
            startDate: Number(startDate),
            endDate: Number(endDate),
            appHash,
        },
        operationName: 'qABotHistory',
    })
}
